import { render, staticRenderFns } from "./largeSizeDetails.vue?vue&type=template&id=1e607bb3&scoped=true&"
import script from "./largeSizeDetails.vue?vue&type=script&lang=js&"
export * from "./largeSizeDetails.vue?vue&type=script&lang=js&"
import style0 from "./largeSizeDetails.vue?vue&type=style&index=0&id=1e607bb3&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e607bb3",
  null
  
)

export default component.exports